export default __webpack_public_path__ + "static/media/swamp.7e20f504.png";